import InterviewType from './InterviewType.component';

export default InterviewType;
